module.exports = {
	"uk": {
		"translation": {
			"moreInformation": "докладніше",
			"close": "Закрити",
			"uploader": {
				"overlay": {
					"title": "Перетягніть",
					"subtitle": "Ваші файли тут"
				},
				"form": {
					"dragAndDrop": "Перетягніть",
					"or": "або",
					"chooseFiles": "Оберіть файли",
					"from": "З вашого комп’ютера"
				},
				"errors": {
					"file_size": "файл перевищує максимальний розмір {{size}}.",
					"file_type": "{{type}} — неправильний тип файлу."
				},
				"status": {
					"idle": "бездіяльність",
					"processing": "обробка",
					"uploading": "завантаження",
					"success": "успіх",
					"cancel": "скасувати",
					"error": "помилка",
					"none": ""
				}
			},
			"actions": {
				"delete": "Видалити",
				"apply": "Застосувати",
				"cancel": "Скасувати"
			},
			"dateInput": {
				"choose": "Вибрати дату",
				"clear": "Очистити дату"
			},
			"daterange": {
				"last_7_days": "Останні 7 днів",
				"last_30_days": "Останні 30 днів",
				"this_month": "Цього місяця",
				"last_month": "Минулого місяця",
				"start_date": "Дата початку",
				"end_date": "Дата закінчення",
				"not_set": "Не встановлено"
			},
			"comment": {
				"delete": "Видалити коментар"
			},
			"pagination": {
				"intro": "Пагінація зараз на сторінці {{поточна сторінка}}.",
				"page": "Сторінка {{pageNumber}}",
				"ellipsis": "Більше сторінок",
				"prev": "Попередня сторінка",
				"next": "Наступна сторінка"
			},
			"formElement": {
				"optional": "(за бажанням)",
				"required": "(обов’язково)"
			},
			"prevNextArrowButton": {
				"arrowup": "вгору",
				"arrowdown": "вниз",
				"escape": "вийти"
			},
			"externalLink": {
				"view": "вигляд"
			},
			"collapsible": {
				"ariaText": "розбірна секція"
			}
		}
	}
};